<button *ngIf="!iconOnly" mat-stroked-button color="primary" (click)="openMobileUploadDialog()">
    <mat-icon svgIcon="qr_code" />
    {{ 'FILE-PROCESS.process-detail.mobile-upload.button-text' | translate }}
</button>
<button *ngIf="iconOnly" mat-icon-button
    [matTooltip]="'FILE-PROCESS.process-detail.mobile-upload.button-text' | translate" matTooltipPosition="above"
    color="primary" (click)="openMobileUploadDialog()">
    <mat-icon svgIcon="qr_code" />
</button>